import { useToast } from '@chakra-ui/react';
import { CellProps, WSysTable, useWSysHub, useWSysLayoutContext, useWSysPage, useWSysPath } from "@coimbra-its/websys-ux-core";
import { useEffect, useState } from 'react';
import { SunBlock, SunButton, SunPage, SunStack, SunValue, dispYearMonth, extractError2, formatAmount } from "../components/Sun";
import { ISunPayout, SunState, useSunStore } from '../store/sunSlice';

const CELLS: CellProps<ISunPayout>[] = [
    { title: 'Date', elem: row => dispYearMonth(row.date) },
    //{ title: 'Status', elem: row => row.status },
    { title: 'Amount', elem: row => formatAmount(row.userAmount) },
]

export function WithdrawSDBN3() {

    const path = useWSysPath();
    const hub = useWSysHub();

    const page = useWSysPage({ title: 'Withdraw SDBN3', maxCols: 2 });

    const connectedWallet = useSunStore((state: SunState) => state.connectedWallet);
    const payoutInfo = useSunStore(state => state.payoutInfoSDBN3);
    const loadPayouts = useSunStore(state => state.loadPayoutsSDBN3);
    const loadBalance = useSunStore(state => state.loadBalance);

    const [payoutList, setPayoutList] = useState<ISunPayout[]>([]);
    useEffect(() => {
        setPayoutList([...payoutInfo.payouts]);
    }, [payoutInfo]);

    const toast = useToast();

    const doLoadPayouts = async () => {
        hub.tryCatch(async () => {
            await loadPayouts();
            toast({ status: 'success', description: 'payouts loaded' })
        });
    }

    useEffect(() => {
        if (connectedWallet) {
            hub.tryCatch(async () => {
                await loadPayouts();
            });
        }
    }, [connectedWallet?.address])

    const doWithdraw = async () => {
        hub.tryCatch(async () => {
            await connectedWallet?.PayoutContractSDBN3.withdraw();
            await loadPayouts();
            await loadBalance();
        });
    }


    const { isMobileFull } = useWSysLayoutContext();

    return <SunPage page={page} hubs={[hub]} pb={0} >
        <SunStack mb={2}>
            <SunBlock header='Sum payouts' flexDir='row' gap={2}>
                <SunValue dim='USDT'>{formatAmount(payoutInfo.userSum)}</SunValue>
            </SunBlock>
            <SunBlock header='Already withdrawn' flexDir='row' gap={2}>
                <SunValue dim='USDT'>{formatAmount(payoutInfo.userWithdrawn)}</SunValue>
            </SunBlock>
            <SunBlock header='Withdraw now' py={3} flexDir={isMobileFull?'column':'row'} gap={2}>
                <SunButton variant='primary' onClick={doWithdraw} >{`Withdraw ${formatAmount(payoutInfo.withdrawAble)} USDT`}</SunButton>
            </SunBlock>

            <SunBlock>
                <SunButton variant='outline' onClick={doLoadPayouts} >Reload payouts</SunButton>
            </SunBlock>

        </SunStack>

        <WSysTable
            cells={CELLS}
            rows={payoutList}
        />

    </SunPage>
}